import {
  Edit3Icon,
  LayoutDashboard,
  Package,
  ShoppingCart,
  Users,
  Wallet,
} from "lucide-react";

export default function CompanyTabs({ currentTab, setCurrentTab, entityType, isRetailerMobile }) {
  const tabs = [
    { key: 0, label: "Sales", icon: ShoppingCart },
    { key: 1, label: "Overview", icon: LayoutDashboard },
    { key: 2, label: "Products", icon: Package }, // company only
    { key: 3, label: "Users", icon: Users },     // company + agent
    { key: 4, label: "Accounts", icon: Wallet }, // all
     // all
    { key: 5, label: "Remarks", icon: Edit3Icon }, // all
  ];

  const visibleTabs = tabs.filter((tab) => {
    // ❌ Hide Products → only company
    if (tab.key === 2) {
      return entityType === "company";
    }

    // ❌ Hide Remarks → only retailer
    if (tab.key === 5) {
      return entityType === "retailer";
    }

    // ❌ Hide Accounts for retailer_user (role 6)
    if (tab.key === 4) {
      return entityType !== "retailer_user";
    }

    // ✅ Show remaining tabs
    return ["company", "agent", "retailer", "retailer_user"].includes(entityType);
  });

  return (
    <div
  className={`sticky top-0 z-30 mb-6 transition-all duration-300
  ${
    isRetailerMobile
      ? "bg-white/10 backdrop-blur-xl border-b border-white/20"
      : "border-b border-blue-100 bg-white"
  }`}
>
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <div
          className={`flex gap-2 overflow-x-auto py-3 px-1
          ${
            isRetailerMobile
              ? "scrollbar-none"
              : ""
          }`}
        >
          {visibleTabs.map((tab) => {
            const Icon = tab.icon;
            const active = currentTab === tab.key;

            return (
              <button
                key={tab.key}
                onClick={() => setCurrentTab(tab.key)}
                className={`flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-bold transition whitespace-nowrap
                ${
                  isRetailerMobile
                    ? active
                      ? "bg-white/20 text-black border border-white/30"
                      : "bg-white/10 text-black/70 border border-white/20 hover:bg-white/20"
                    : active
                    ? "bg-blue-600 text-white"
                    : "bg-blue-50 text-blue-700 hover:bg-blue-100"
                }`}
              >
                <Icon
                  className={`h-4 w-4 ${
                    isRetailerMobile ? "text-black/80" : ""
                  }`}
                />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}




// import { LayoutDashboard, Package, ShoppingCart, Users, Wallet } from "lucide-react";

// export default function CompanyTabs({ currentTab, setCurrentTab, entityType }) {

//   const tabs = [
//     { key: 0, label: "Overview", icon: LayoutDashboard },
//     { key: 1, label: "Products", icon: Package },
//     { key: 2, label: "Users", icon: Users },
//     { key: 3, label: "Accounts", icon: Wallet },
//     { key: 4, label: "Sales", icon: ShoppingCart },
//   ];

//   return (
//     <div className="sticky top-0 z-30 mb-6 border-b border-blue-100 bg-white">
//       <div className="mx-auto max-w-6xl px-4 md:px-8">
//         <div className="flex gap-2 overflow-x-auto py-3">
//           {tabs.map((tab) => {
//             const Icon = tab.icon;
//             const active = currentTab === tab.key;

//             return (
//               <button
//                 key={tab.key}
//                 onClick={() => setCurrentTab(tab.key)}
//                 className={`flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-bold transition
//                    ${active ? "bg-blue-600 text-white" : "bg-blue-50 text-blue-700 hover:bg-blue-100"}
//                 `}
//               >
//                 <Icon className="h-4 w-4" />
//                 {tab.label}
//               </button>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// }
